
import { defineComponent } from "vue";
import "@/assets/scss/admin/add-doctor.scss";
import axios from "axios";
import DatePicker from "vue3-persian-datetime-picker";
import LoadingScreen from "@/components/LoadingScreen.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "add-doctor",
  components: { DatePicker, LoadingScreen },
  data() {
    return {
      isLoading: true,
      active: false,
      doctors: [],
      first_name: "",
      last_name: "",
      mobile: "",
      specialty: "",
      address: "",
      birthday: "",
      user_name: "",
      password: "",
      gender: "male",
      male: "male",
      famale: "famale",
      national_code: "",
      isNullFirsName: false,
      isNullLastName: false,
      isNullBirthday: false,
      isNullMobile: false,
      isNullNationalCode: false,
      isNullAddress: false,
      isNullUserName: false,
      isNullPassword: false,
      isNullSpecialty: false,
    };
  },
  methods: {
    fetchDoctors() {
      axios
        .get("/doctors")
        .then((res) => {
          //console.log(res);
          this.isLoading = false;
          this.doctors = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveDoctor() {
      let sccess = false;
      if (this.first_name === "") {
        this.isNullFirsName = true;
      } else {
        this.isNullFirsName = false;
        sccess = true;
      }
      if (this.last_name === "") {
        this.isNullLastName = true;
      } else {
        this.isNullLastName = false;
        sccess = true;
      }
      if (this.birthday === "") {
        this.isNullBirthday = true;
      } else {
        this.isNullBirthday = false;
        sccess = true;
      }
      if (this.mobile === "") {
        this.isNullMobile = true;
      } else {
        this.isNullMobile = false;
        sccess = true;
      }
      if (this.national_code === "") {
        this.isNullNationalCode = true;
      } else {
        this.isNullNationalCode = false;
        sccess = true;
      }
      if (this.address === "") {
        this.isNullAddress = true;
      } else {
        this.isNullAddress = false;
        sccess = true;
      }
      if (this.user_name === "") {
        this.isNullUserName = true;
      } else {
        this.isNullUserName = false;
        sccess = true;
      }
      if (this.password === "") {
        this.isNullPassword = true;
      } else {
        this.isNullPassword = false;
        sccess = true;
      }
      if (this.specialty === "") {
        this.isNullSpecialty = true;
      } else {
        this.isNullSpecialty = false;
        sccess = true;
      }
      if (
        sccess == true &&
        this.isNullFirsName == false &&
        this.isNullLastName == false &&
        this.isNullBirthday == false &&
        this.isNullMobile == false &&
        this.isNullNationalCode == false &&
        this.isNullAddress == false &&
        this.isNullUserName == false &&
        this.isNullPassword == false
      ) {
        axios
          .post("/doctors", {
            first_name: this.first_name,
            last_name: this.last_name,
            birthday: this.birthday,
            gender: this.gender,
            mobile: this.mobile,
            address: this.address,
            specialty: this.specialty,
            national_code: this.national_code,
            username: this.user_name,
            password: this.password,
          })
          .then(() => {
            // console.log(res);
            window.alert("دکتر با موفقیت ثبت شد");
            this.active = false;
            this.fetchDoctors();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.fetchDoctors();
  },
});
